import React from 'react';
import styles from '../Operations.module.css';

interface BTSPComponent extends React.FC {
  title?: string;
}

const BTSP: BTSPComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Review the customer segmentation in your POS system to be sure all business customers are being counted.
        <br />
        <br />
        Your B2B Field Sales Manager can assist by providing a report (Alteryx Segmentation Report) that shows all customers in your system and the segment that is tied to them. 
        <br />
        <br />
        This report is for Epicor Eagle for Windows and Propello systems only.  
        <br />
        <br />
        For more information on segmentation, go to <a
          href="https://acenet.aceservices.com/awor/b2b-operations-and-processes/b2b-customer-segmentation"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          AWOR &gt; Business to Business - B2B Operations and Processes &gt; B2B Customer Segmentation
        </a>. 
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        This metric is dependent on stores completing and maintaining their business customer segmentation.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        Higher ground goals: achieve one of the two B2B metrics, B2B sales as a percent of total sales or B2B sales growth.
        <br /><br />
        <strong>Platinum:</strong> Achieve growth of at least 7% or 10% of your total sales going to a B2B customer during a rolling 12 month period (minimum 5% B2B to Total).
        <br /><br />
        <strong>Pinnacle:</strong> Achieve growth of at least 10% or 15% of your total sales going to a B2B customer during a rolling 12 month period (minimum 5% B2B to Total).
        <br /><br />
        <strong>Requirements:</strong> Must achieve 5% B2B to Total to start the climb to Higher Ground.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Go to the B2B Homepage on ACENET{' '}
        <a
          href="https://acenet.aceservices.com/b2b-business-to-business"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          (ACENET &gt; Growth Drivers &gt; B2B-Business to Business)
        </a>
        {' '}to get started on the B2B action plan.
        <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Appoint a B2B Champion and assign training.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Ensure the B2B Champion and Leadership are signed up to receive monthly B2B sales reports.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Implement a process to set up new B2B customers in store.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Contact customers to learn more about their supply needs.
      </div>
    </div>
  );
};

BTSP.title = 'Business to Business Metrics (Percent to Total)';
export default BTSP;

